import React from 'react';
import { Button, Typography } from 'antd';
import { RocketOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Routes from '~/routes/routes';
import { LandingPageUtil } from './LandingPageUtil';

const { Title, Paragraph } = Typography;

const fadeUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
    viewport: { once: true },
};

interface CTASectionProps {
    onNavigateToProjects?: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onNavigateToProjects }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleContinue = () => {
        if (onNavigateToProjects) {
            onNavigateToProjects();
        } else {
            navigate(Routes.PROJECT);
        }
    };

    return (
        <div
            style={{
                position: 'relative',
                zIndex: 1,
                padding: '60px 20px',
                textAlign: 'center',
                background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(20,30,50,0.5) 100%)',
            }}
        >
            <motion.div {...fadeUp} style={{ maxWidth: 800, margin: '0 auto' }}>
                <Title level={2} style={{ color: '#fff', fontSize: '1.75rem', marginBottom: 12 }}>
                    {t('landing__cta_title')}
                </Title>
                <Paragraph style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.95rem', marginBottom: 24 }}>
                    {t('landing__cta_description')}
                </Paragraph>

                <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Button
                        type="primary"
                        size="large"
                        icon={<RocketOutlined />}
                        style={{
                            height: 44,
                            padding: '0 28px',
                            fontSize: 14,
                            fontWeight: 600,
                            borderRadius: 10,
                            background: 'linear-gradient(135deg, #69c0ff, #d3adf7)',
                            border: 'none',
                            color: '#000',
                        }}
                        onClick={handleContinue}
                    >
                        {t('landing__btn_continue')}
                    </Button>

                    <Button
                        size="large"
                        icon={<PlayCircleOutlined />}
                        style={{
                            height: 44,
                            padding: '0 28px',
                            fontSize: 14,
                            fontWeight: 600,
                            borderRadius: 10,
                            background: 'transparent',
                            border: '2px solid rgba(255,255,255,0.3)',
                            color: '#fff',
                        }}
                        onClick={() => {
                            LandingPageUtil.openDocumentation();
                        }}
                    >
                        {t('landing__btn_book_demo')}
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default CTASection;
